var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('BlockCurtain'),_c('MainMenu'),_c('transition',{attrs:{"name":"router-anim"},on:{"enter":_vm.transitionIn,"leave":_vm.transitionOut}},[_c('router-view')],1),_c('Cookies')],1)}
var staticRenderFns = []

export { render, staticRenderFns }